// The "Zuletzt" chip row (workspace-start M3): recents from every module
// dashboard that answered `ok`, merged into one row at the end of the page.
// Pure function, no Vue — mirrors the shape of utils/heute.ts.
import type { ModuleDashboard, RecentItem } from './homebase';

export interface MergedRecent extends RecentItem {
  moduleKey: string;
}

/**
 * Newest first by `at`; items with no `at` come after every dated item, in
 * MODULE order (the same `order` the Heute row and the bands receive) — never
 * reordered relative to each other within that. Capped at `cap`, no "load
 * more" (Decisions made).
 */
export function mergeRecents(
  dashboards: Record<string, ModuleDashboard | null>,
  order: readonly string[],
  cap = 8,
): MergedRecent[] {
  const dated: MergedRecent[] = [];
  const undated: MergedRecent[] = [];
  for (const moduleKey of order) {
    const dashboard = dashboards[moduleKey];
    if (!dashboard) continue;
    for (const item of dashboard.recents) {
      const merged: MergedRecent = { ...item, moduleKey };
      (item.at ? dated : undated).push(merged);
    }
  }
  // Array#sort is stable (ES2019+): equal timestamps keep the module order
  // they were pushed in above.
  dated.sort((a, b) => new Date(b.at as string).getTime() - new Date(a.at as string).getTime());
  return [...dated, ...undated].slice(0, cap);
}
